var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('FormAuction',{attrs:{"loading":_vm.loading,"getAuctionById":_vm.getOneAuction,"idAuction":_vm.idAuction,"idCategoryAuction":_vm.idCategory},on:{"beforeUpdate":_vm.updateAuction,"beforeCreate":_vm.createAuction}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }